import React from 'react';
import { connect } from "react-redux";
import { generateOtp, validateOtp } from './../../../actions/crossSellApplicationActions';
import { otpSelectionDataLayer, otpEnterPinDataLayer } from "./../../../analytics/adobe/dataLayerValues";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "./../../../analytics/adobe/index";
import './Otp.scss';

class Otp extends React.Component {

  state = {
    showOTPSecondPage: false,
    showOTPFirstPage: true,
    showCongrats: false,
    showError: false,
    dataInfo: this.props.data.map(comm=>{
      let temp=comm;
      temp.selectedCommMethod='';
      return temp;
    }),
    generatedOtpResponse: null,
    otpValue: '',
    isNextBtnDisable: true,
    isContinueBtnDisable: true,
    currentCommunicationMethod: '',
    btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null
  };

  constructor(props) {
    super(props);
  }

  componentDidMount(){
    const { pageName, siteSection }=otpSelectionDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  componentDidUpdate(prevProps, nextState){
    if(prevProps.generatedOtpResponse !== this.props.generatedOtpResponse && this.props.generatedOtpResponse!==null ){
      this.setState({
        showOTPSecondPage: !this.state.showOTPSecondPage,
        showOTPFirstPage: !this.state.showOTPFirstPage,
        generatedOtpResponse: this.props.generatedOtpResponse
      }, e=>{
        this.handleAnalyticsChange();
      });
    } else if(prevProps.data !== this.props.data && this.props.data!==null){
      this.setState({
        showOTPSecondPage: false,
        showOTPFirstPage: true,
        otpValue: '',
        dataInfo: this.props.data.map(comm=>{
          let temp=comm;
          temp.selectedCommMethod='';
          return temp;
        })
      });
    }
  }

  handleAnalyticsChange(){
    const { showOTPFirstPage, showOTPSecondPage } = this.state;
    if(showOTPFirstPage){
      const { pageName, siteSection }=otpSelectionDataLayer;
      updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
    } else if(showOTPSecondPage){
      const { pageName, siteSection }=otpEnterPinDataLayer;
      updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
    }
  }

  getCommunicationMethodType(type){
    let res=null;
    switch(type){
    case 'VOICE':
      res= {
        title: 'Phone call',
        subTitle: 'Call me at '
      };
      break;
    case 'EMAIL':
      res= {
        title: 'Email',
        subTitle: 'Email me at '
      };
      break;
    case 'SMS':
      res= {
        title: 'Text message',
        subTitle: 'Text me at '
      };
      break;
    }
    return res;
  }

  handleCommunicationMethodSelection(e, selectedIndex){
    let methods= this.state.dataInfo;
    let selectedCommunicationMethod = '';
    methods.map((item, index)=>{
      if(index===selectedIndex){
        item.selectedCommMethod= e.currentTarget.value;
        selectedCommunicationMethod= item.masked;
      } else {
        item.selectedCommMethod="";
      }
    });
    let checkSelectionIsMade=methods.some(v=>v.selectedCommMethod.length>0);
    this.setState({
      dataInfo: methods,
      isNextBtnDisable: !checkSelectionIsMade,
      currentCommunicationMethod: selectedCommunicationMethod
    });
  }

  handleNextButtonClick(){
    let temp = this.state.dataInfo;
    let selected=temp.filter(v=>v.selectedCommMethod.length>0)[0];
    let bankInfo =this.props.bankInfo;
    this.props.generateOtp(selected.id, this.props.verificationContextsId, bankInfo);
  }

  handleOtpInputChange(e) {
    const re = /^[0-9\b]+$/;
    let val =e.target.value;
    let checkContinueBtnState=!val.length>0;
    if (val === '' || re.test(val)) {
      this.setState({
        otpValue: val,
        isContinueBtnDisable: checkContinueBtnState
      });
    }
  }

  handleContinueBtnClick(){
    let otpResponseId=this.state.generatedOtpResponse.data.id;
    let hasAttemptsLeft=this.state.generatedOtpResponse.data&&this.state.generatedOtpResponse.data.attributes.generationAttemptsRemaining !== 0;
    let bankInfo =this.props.bankInfo;
    //Submit OTP value
    this.props.validateOtp(otpResponseId, this.state.otpValue, bankInfo, hasAttemptsLeft, this.props.challengeType);
  }

  render = () => {
    const { showOTPSecondPage, showOTPFirstPage, dataInfo } = this.state;
    let checkDisableBtn = (this.props.disableContinueBtnPerm == "update_power_curve") || (this.props.disableContinueBtnPerm =="approved")?true:this.state.isContinueBtnDisable;
    return (
      <div className="otp-page-font">
        { showOTPFirstPage && (
          <div className="otp-first-page">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-xs-12">
                  <p>To ensure your account is secure, we need to confirm your identity, to do this we'll send a SecurPass<span className="ordinal-trademark">TM</span> code to the email address or phone number associate with your account.</p>
                  <div className="row">
                    <div className="col-md-6 col-xs-12 padding-between">
                      <h3 className="header-font standard-blue select-delivery">Select a delivery method</h3>
                      <p className="text-16">Choose how you'd like to receive your SecurPass<span className="ordinal-trademark">TM</span> code, then click Next. On the following page, enter the SecurPass<span className="ordinal-trademark">TM</span> code you received.</p>
                      <p className="text-16">Please note: This SecurPass<span className="ordinal-trademark">TM</span> code can only be used once and it expied within 10 minutes.</p>
                      <p className="standard-msg-txt hidden-xs">Standard messaging and data rates may apply. Selecting to receive your SecurPass<span className="ordinal-trademark">TM</span> code does not after the other preferences or settings related to your account.</p>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <ul className="list-group cl-list">
                        {
                          dataInfo.map((commMethod, index)=>{
                            return(
                              <li className="list-group-item cl-list-item d-flex align-items-center" key={`communication-method-${index}`}>
                                <span className="badge">
                                  <div className="idv-otp-radio cl-rdio cl-rdio-primary radio-inline">
                                    <input
                                      name={`otp-radio-${index}`}
                                      id={`otp-radio-id-${index}`}
                                      value={commMethod.type}
                                      className="idv-radio-button"
                                      checked={commMethod.selectedCommMethod===commMethod.type}
                                      type="radio"
                                      onChange={e=>this.handleCommunicationMethodSelection(e, index)}
                                      onKeyDown={e=>{
                                        if(e.keyCode===13){
                                          e.target.blur();
                                        }
                                      }}
                                      aria-labelledby={`otp-radio-label-${index}`}
                                    />
                                    <label htmlFor={`otp-radio-id-${index}`} />
                                  </div>
                                </span>
                                <div className="otp-selection" id={`otp-radio-label-${index}`}>
                                  <div className="cl-h5title">{`${this.getCommunicationMethodType(commMethod.type).title}`}</div>
                                  <span className="cl-sub-title">{`${this.getCommunicationMethodType(commMethod.type).subTitle} ${commMethod.masked}`}</span>
                                </div>
                              </li>
                            );
                          })
                        }
                      </ul>
                      <p className="standard-msg-txt hidden-md margin-standard-msg-txt">Standard messaging and data rates may apply. Selecting to receive your SecurPass<span className="ordinal-trademark">TM</span> code does not after the other preferences or settings related to your account.</p>
                      <div className="col-xs-12 col-md-12 col-sm-12 next-btn-wrapper">
                        <button type="submit" disabled={this.state.isNextBtnDisable}
                          aria-label="click to go to next page to enter the OTP"
                          className={`btn btn-primary checkingTabLeft button-override-color next-btn-otp ${this.state.isNextBtnDisable?'otp-btn-disabled':''}`}
                          onClick={e=>this.handleNextButtonClick()}>Next</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        { showOTPSecondPage && (
          <div className="otp-second-page">
            <div className={this.state.showError? 'errors-container show-block-error' : 'errors-container hide-block-error'} role="alert">
              <span className="clapply-icon exclamation-mark error-red error-exclamation-mark">&#9432;</span>
              <h5 className="congratulations header-font standard-blue select-delivery">Errors found. Please see details below.
                <span className="times-right-align">&times;</span></h5>
              <div className="congrats-text">
                <p className="standard-blue">Please enter the SecurPass<span className="ordinal-trademark">TM</span> code. To have another SecurPass<span className="ordinal-trademark">TM</span> code sent, please <a href="#">click here</a> to go back to the delivery options</p>
              </div>
            </div>
            <div className={this.state.showCongrats? 'congrats-container show-block-congrats' : 'congrats-container hide-block-congrats'} role="alert">
              <span className="congrats-checkmark"></span>
              <h5 className="congratulations header-font standard-blue select-delivery">Congratulations!
                <span className="times-right-align">&times;</span></h5>
              <div className="congrats-text">
                <p className="standard-blue">Your card is now activated, and can be used immediately. Please continue to setup your PIN below, If you already have a PIN and keep it, please enter it below.</p>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-xs-12">
                  <div className="row">
                    <div className="col-md-6 col-xs-12 padding-between">
                      <h3 className="header-font standard-blue select-delivery">Enter your SecurPass<span className="ordinal-trademark">TM</span> code</h3>
                      <p>Check {this.state.currentCommunicationMethod} for your temporary SecurPass<span className="ordinal-trademark">TM</span> code. Enter this SecurPass<span className="ordinal-trademark">TM</span> code on the same device you used to request it - before it expires within 10 minutes.</p>
                      <p className="standard-msg-txt hidden-xs">Standard messaging and data rates may apply. Selecting to receive your SecurPass<span className="ordinal-trademark">TM</span> code does not after the other preferences or settings related to your account.</p>
                    </div>
                    <div className="col-md-5 col-xs-12">
                      <p className="securepasscode-font standard-blue select-delivery" id="enterOTP">Enter your SecurPass<span className="ordinal-trademark">TM</span> code</p>
                      <input type="tel"
                        className={`idv-otp-input standard-blue`}
                        maxLength="6"
                        id="idv-otp-input"
                        value={this.state.otpValue}
                        onKeyDown={e=>{
                          if(e.keyCode===13){
                            e.target.blur();
                          }
                        }}
                        onChange={e=>this.handleOtpInputChange(e)}
                        placeholder="Enter your 6 digit code"
                        aria-labelledby="enterOTP"/>
                      <p className={this.state.showError? 'error-red otp-err-text show-block-error' : 'error-red otp-err-text hide-block-error'}> <b>Error:</b> Please enter the SecurPass<span className="ordinal-trademark">TM</span> code that we sent to you. Didn't receive a SecurPass<span className="ordinal-trademark">TM</span> code? Click the "Back to recovery options" link below</p>
                      <p>
                        <a href="#" className="recovery-link" onClick={() => {
                          this.setState({
                            showOTPFirstPage: !this.state.showOTPFirstPage,
                            showOTPSecondPage: !this.state.showOTPSecondPage
                          }, e=>{
                            this.handleAnalyticsChange();
                          });
                        }}>Back to review options</a>
                      </p>
                      <p className="standard-msg-txt hidden-md margin-standard-msg-txt">Standard messaging and data rates may apply. Selecting to receive your SecurPass<span className="ordinal-trademark">TM</span> code does not after the other preferences or settings related to your account.</p>
                      <div className="col-xs-12 col-md-12 next-btn-wrapper">
                        <button type="submit"
                          disabled={checkDisableBtn}
                          data-track="custom-links"
                          className={`btn btn-primary checkingTabLeft button-override-color next-btn-otp ${checkDisableBtn?'otp-btn-disabled':''}`}
                          onClick={() => this.handleContinueBtnClick()}
                          aria-label="click on continue button to confirm">Continue</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generatedOtpResponse: state.creditCardApplicant !==null?state.creditCardApplicant.generateOtpResponse:null,
    disableContinueBtnPerm: state.creditCardApplicant.disableContinueBtnPerm
  };
};

const mapDispatchToProps = {
  generateOtp: generateOtp,
  validateOtp: validateOtp
};

export default connect(mapStateToProps, mapDispatchToProps)(Otp);
